// extracted by mini-css-extract-plugin
export default {"header":"SectionWatchlistListings_header__FiSz7","title":"SectionWatchlistListings_title__bP+4A","sliderItem":"SectionWatchlistListings_sliderItem__0X+NH"};